module.exports = __webpack_public_path__ + "static/img/moreproduct2.fd50e2f6.png";